import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import '../../style.scss';

const ModalBody = ({ children, isGrey, isFlat, className }) => (
  <section
    styleName={classnames('modal__body', {
      'is-grey': isGrey,
      'is-flat': isFlat,
    })}
    className={className}
    data-test="modal-body"
  >
    {children}
  </section>
);

ModalBody.propTypes = {
  children: PropTypes.node,
  isGrey: PropTypes.bool,
  isFlat: PropTypes.bool,
  className: PropTypes.string,
};

ModalBody.defaultProps = {
  children: null,
  isGrey: false,
  isFlat: false,
};

export default ModalBody;
